import WorkspaceClass from './Workspace/WorkspaceClass'
import LeftMenuClass from './LeftMenu/LeftMenuClass'
import LeftMenuExClass from './LeftMenu/LeftMenuExClass'
import MenuBarClass from './MenuBar/MenuBarClass'
import PageMenuExClass from './PageMenuEx/PageMenuExClass'
import ObjectsMenuEx from './ObjectsMenuEx/ObjectsMenuEx'
import HierarchyMenuExClass from './HierarchyMenuEx/HierarchyMenuExClass'
import SpreadsheetMenuExClass from './SpreadsheetMenuEx/SpreadsheetMenuExClass'
import PropertiesClass from './Properties/PropertiesClass'

const components = {
    WorkspaceClass, LeftMenuClass, MenuBarClass,
    LeftMenuExClass, PageMenuExClass, ObjectsMenuEx, HierarchyMenuExClass,
    SpreadsheetMenuExClass, PropertiesClass
}

export default components;